import { createRoute } from "@routes/utils";

import { dashboardRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = "all";

const dashboardRouteMetadata: IRouteMetadataObj<typeof dashboardRoutesObj> = {
  home: {
    title: "dashboard.title",
    description: "empty",
    lazy: () => import("src/pages/dashboard/page"),
    mode: "index",
    type: "main",
    icon: "Home3Line",
    breadcrumbs: [],
    permission,
  },
};

export const dashboardRoutes = createRoute<typeof dashboardRoutesObj>(
  dashboardRoutesObj,
  dashboardRouteMetadata,
);
